import { CardInternal, type CardProps } from '../CardInternal'
import { BaseCardFooter } from '../BaseCard.Footer'
import { BaseCardContent } from '../BaseCard.Content'
import { BaseCardHeader } from '../BaseCard.Header'
import { BaseCardArea } from '../BaseCardArea'

/**
 * The <Card> component is a flexible container used to group content and actions about a single subject.
 * It can hold text, media, toolbars, and buttons, and adapts to both mobile and desktop layouts. Cards help
 * structure information clearly and support nested design elements through modular composition.
 *
 *  Demos:
 * - [Card](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/constructs-card-card--docs)
 *
 */
const Card = (props: CardProps) => <CardInternal {...props} />

Card.Content = BaseCardContent
Card.Header = BaseCardHeader
Card.Footer = BaseCardFooter

/**
 * Place inside the Card with a `href` for link or `onClick` for Button
 * **Do not place any other interactive element inside the Card when consuming `Card.Area`**
 */
Card.Area = BaseCardArea

export { Card, type CardProps }
